import { AfterContentChecked, ChangeDetectorRef, Component, ErrorHandler, Injector, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy, inject, signal } from '@angular/core'
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms'
import { applyEach, disabled, FieldTree, form, required } from '@angular/forms/signals'
import { MatInput } from '@angular/material/input'
import { ActivatedRoute, Router } from '@angular/router'

import { FirebaseLemonaid, FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'

import { arvonMuutokset, asetaArvo, nollaa } from '../_jaettu-angular/_lomakkeet/arvon-muutokset'
import { validoiReaktiivisesti } from '../_jaettu-angular/_lomakkeet/reaktiivinen-validaattori'
import { FieldErrors, FormValidationService } from '../_jaettu-angular/service/form-validation.service'
import { LadataanService } from '../_jaettu-angular/service/ladataan.service'

import { BehaviorSubject, combineLatest, firstValueFrom, Observable, of, Subject } from 'rxjs'
import { map, switchMap, takeUntil } from 'rxjs/operators'

import { KayttajanLaite, KayttajanLaitteet, KayttajanTunnistamisStatus, SelvitettavienNakyvyys, UserFeature } from '@lemon/core-firebase/model/kayttaja'
import { LoginInformation } from '@lemon/core-firebase/model/login'
import { PushIlmoitusUriService } from '@lemon/core-firebase/service/push-ilmoitus-uri.service'
import { Asiakas, AsiakkaanMaksutapa, Kayttaja, TaikalinkkiLahetysHistoria, TallennaKayttajaPyynto, TallennaKayttajaVastaus, TallennaTaikalinkkiType } from '../_jaettu-lemonator/model/asiakas'
import { AloitaKayttajanaKirjautuminenPyynto } from '../_jaettu-lemonator/model/kirjanpitaja'

import { Roolit, TositteenLisaysprosessinAlvVahennysoikeusPorras, TositteenLisaysprosessinOsaMobiilissa, TositteenLisaysprosessinOsanTunniste } from '@lemon/core-firebase/model/kayttaja'
import { DateService } from '@lemon/core/service/date.service'

import { MatDialog } from '@angular/material/dialog'
import { SopimuksenHyvaksynnanHistoria } from '@lemon/core-firebase/model/sopimus'
import { StrongAuthenticationSessionHistory } from '@lemon/core-firebase/model/tunnistaminen'
import { StringService } from '@lemon/core/service/string.service'
import { LahetettySahkoposti, LahetettySms } from '@lemon/lemonaid-lemonator-functions-and-lemonator-angular/model/lahetetty-viesti'
import { DebugService } from 'app/_angular/service/debug.service'
import { KirjautunutKayttajaService } from 'app/_angular/service/kirjautunut-kayttaja.service'
import { NakymaOikeusService } from 'app/_angular/service/nakyma-oikeus.service'
import { LemonatorNakyma } from '../_jaettu-lemonator/model/lemonator-nakyma'
import { MoniyritystuenReplika } from '../_jaettu-lemonator/model/moniyritys'
import { AreYouSureDialog, AreYouSureDialogData } from 'app/_jaettu-angular/_components/are-you-sure.dialog'
import { KayttajaComponentData } from '../_angular/_resolvers/asiakas.resolve'
import { AsiakasService, AsiakkaanAvainTiedot } from '../_angular/service/asiakas/asiakas.service'
import { KayttajaKopioija } from '../_angular/service/asiakas/kayttaja.kopioija'
import { FormValidators } from '../_jaettu-angular/_validators/FormValidators'
import { KayttajaHaluatkoVarmastiLahettaaTaikalinkinDialog } from './kayttaja.haluatko-varmasti-lahettaa-taikalinkin.dialog'
import { KayttajaHistoriaDialog } from './kayttaja.historia.dialog'
import { KayttajaLoginHistoryDialog } from './kayttaja.login-history.dialog'
import { KayttajaStrongAuthHistoryDialog } from './kayttaja.strong-auth-history.dialog'
import { KayttajaVaihdaSalasanaDialog } from './kayttaja.vaihda-salasana.dialog'

export interface MuokkausprosessinOsa {
  lisaysProsessinOsa: TositteenLisaysprosessinOsaMobiilissa
  valittu: boolean
}
interface LuvatJaSopimukset {
  asiakasLuotu: string
  kayttajaLuotu: string
  // lastLogin: string
  // tupas: string
  hetu: string
  tunnistamisStatus: KayttajanTunnistamisStatus
  // sopimukset: {[key: string]: string }
  // kayttoehdot: {[key: string]: string }
}

interface MoniyritystukiNakyma {
  tukiAvain: string
  kayttajaAvain: string
  replikaUri: string
  tuki: MoniyritystuenReplika | null
}

interface LahetettyViestiRivi {
  avain: string
  pvm: string
  tyyppiTeksti: string
  kanavaTeksti: string
  vastaanottaja: string
  esikatselu: string
  sisaltoText: string
  naytaSisalto: boolean
}

interface NaytettavaLaite {
  fid: string
  laiteTeksti: string
  alustaTeksti: string
  sovellusTeksti: string
  pushTeksti: string
  ilmoituksetTeksti: string
  rekisteroityTeksti: string
  paivitettyTeksti: string
  tilaTeksti: string
  poistettu: boolean
}

interface AlvPorrasLomake {
  arvo: number | null
  oletus: boolean | null
}

interface MaksutapaValintaLomake {
  kaytossa: boolean
  tunniste: number
}

interface ProsessinOsaLomake {
  aktiivinen: boolean | null
  otsikko: string
  alvPortaat?: AlvPorrasLomake[]
  oletusporras?: number | null
  maksutavat?: MaksutapaValintaLomake[]
}

interface KayttajaLomake {
  etunimi: string
  sukunimi: string
  asiointikieli: string | null
  email: string
  puhelin: string
  aktiivinen: boolean | null
  selvitettavienNakyvyys: SelvitettavienNakyvyys | null
  prosessinOsat: ProsessinOsaLomake[]
  [Roolit.LASKUTUS]: boolean | null
  TOSITTEET: boolean | null
  [Roolit.TOSITTEET_MYYNTI]: boolean | null
  [Roolit.TOSITTEET_OSTO]: boolean | null
  [Roolit.TOSITTEET_PALKKA]: boolean | null
  [Roolit.TOSITTEET_TILI]: boolean | null
  [Roolit.SAHKOISTEN_LASKUJEN_VASTAANOTTO]: boolean | null
  [Roolit.PALKAT]: boolean | null
  [Roolit.MAKSUT]: boolean | null
  [Roolit.MAKSUT_VASTAANOTTAJA]: boolean | null
  [Roolit.MAKSUT_MAKSAJA]: boolean | null
  [Roolit.MAKSUT_HYVAKSYJA]: boolean | null
  [Roolit.RAPORTIT]: boolean | null
  [Roolit.HALLINTO_VIIA_VALTUUTUKSEN_ANTAJA]: boolean | null
  [Roolit.HALLINTO_SOPIMUKSEN_HYVAKSYJA]: boolean | null
  [Roolit.HALLINTO_YHTEYSHENKILO]: boolean | null
  [Roolit.HALLINTO_TUNTEMISTIETOJEN_ANTAJA]: boolean | null
  [Roolit.TUNNISTETAAN]: boolean | null
  [UserFeature.CAN_EDIT_PENALTY_INTEREST]: boolean | null
}

const TYHJA_LOMAKE: KayttajaLomake = {
  etunimi: '',
  sukunimi: '',
  asiointikieli: null,
  email: '',
  puhelin: '',
  aktiivinen: null,
  selvitettavienNakyvyys: null,
  prosessinOsat: [],
  [Roolit.LASKUTUS]: null,
  TOSITTEET: null,
  [Roolit.TOSITTEET_MYYNTI]: null,
  [Roolit.TOSITTEET_OSTO]: null,
  [Roolit.TOSITTEET_PALKKA]: null,
  [Roolit.TOSITTEET_TILI]: null,
  [Roolit.SAHKOISTEN_LASKUJEN_VASTAANOTTO]: null,
  [Roolit.PALKAT]: null,
  [Roolit.MAKSUT]: null,
  [Roolit.MAKSUT_VASTAANOTTAJA]: null,
  [Roolit.MAKSUT_MAKSAJA]: null,
  [Roolit.MAKSUT_HYVAKSYJA]: null,
  [Roolit.RAPORTIT]: null,
  [Roolit.HALLINTO_VIIA_VALTUUTUKSEN_ANTAJA]: null,
  [Roolit.HALLINTO_SOPIMUKSEN_HYVAKSYJA]: null,
  [Roolit.HALLINTO_YHTEYSHENKILO]: null,
  [Roolit.HALLINTO_TUNTEMISTIETOJEN_ANTAJA]: null,
  [Roolit.TUNNISTETAAN]: null,
  [UserFeature.CAN_EDIT_PENALTY_INTEREST]: null,
}

@Component({
  templateUrl: './kayttaja.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KayttajaComponent implements OnInit, OnDestroy, AfterContentChecked {
  @ViewChild(MatInput) etunimiInput: MatInput

  lomake: FieldTree<KayttajaLomake>
  fieldErrors: FieldErrors = {}
  readonly atLeastOneLemonaidRoleError = signal<string>(undefined)
  selvitettavienNakyvyyksienArvot: { nimi: string; arvo: SelvitettavienNakyvyys }[] = [
    { nimi: 'Käyttäjä näkee vain omat selvitettävät (kaikki selvitettävät, jotka ovat hänellä käytössä olevissa maksutavoissa)', arvo: 'omat' },
    { nimi: 'Käyttäjä näkee kaikki selvitettävät', arvo: 'kaikki' },
  ]

  asiakas: Asiakas = null
  asiakkaanMaksutavat: AsiakkaanMaksutapa[] = null
  aktivoitujenMaksutapojenLukumaara = 0
  prosessinOsat: MuokkausprosessinOsa[] = null
  kayttaja: Kayttaja = null
  naytaAlvPortaat: boolean = false
  naytaMaksutavat: boolean = false
  readonly commonError = signal<string>(null)
  luvatJaSopimuksetObservable: Observable<LuvatJaSopimukset>
  lastLoginObservable: Observable<string>
  otsikkoObservable: Observable<string>
  sopimuksienHyvaksynnatObservable: Observable<SopimuksenHyvaksynnanHistoria[]>
  laitteetObservable: Observable<NaytettavaLaite[]>
  lahetetytViestitObservable: Observable<LahetettyViestiRivi[]>
  naytaLisaaLahetettyjaViestejaObservable: Observable<boolean>
  lastMagicLinkSendObservable: Observable<TaikalinkkiLahetysHistoria>
  moniyritystukiNakymaObservable: Observable<MoniyritystukiNakyma>
  moniyritystukiEncodedUriObservable: Observable<string>
  naytaMoniyritystukiLinkkiObservable: Observable<boolean>
  readonly isAdmin = signal<boolean>(undefined)

  kayttajaUriObservable: Observable<string>
  kayttajaEncodedUriObservable: Observable<string>
  sopimustenHyvaksynnatUriObservable: Observable<string>
  sopimustenHyvaksynnatEncodedUriObservable: Observable<string>
  lahetetytViestitUriObservable: Observable<string>
  lahetetytViestitEncodedUriObservable: Observable<string>
  kirjanpitajaOnDevaajaObservable: Observable<boolean>
  kirjanpitajaOnLuottoObservable: Observable<boolean>

  private static readonly LAHETETYT_VIESTIT_SIVUKOKO = 50
  private _lahetetytViestitLimitSubject = new BehaviorSubject<number>(KayttajaComponent.LAHETETYT_VIESTIT_SIVUKOKO)

  private ngUnsubscribe: Subject<void> = new Subject<void>()
  private readonly _injector = inject(Injector)
  private _portaat: FieldTree<AlvPorrasLomake[]> = null
  private _portaatOsa: FieldTree<ProsessinOsaLomake> = null
  private _portaidenLopetukset: Subject<void>[] = []
  private _maksutapojenLopetus = new Subject<void>()
  private _prosessinOsienLopetus = new Subject<void>()
  maksutapaRivit: FieldTree<MaksutapaValintaLomake[]> = null
  private _muidenKayttajienEmailit: string[]
  private _kayttajaAlkuperainenEmail: string
  private _kayttajaAlkuperainenPuhelin: string

  readonly rooliMap = this._asiakasService.KAYTTAJA_ROOLI_DISPLAY_NAMES
  readonly userFeatureMap = this._asiakasService.KAYTTAJA_FEATURE_DISPLAY_NAMES
  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly Roolit = Roolit

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _router: Router,
    private _route: ActivatedRoute,
    private _dialog: MatDialog,
    private _kayttajaKopioija: KayttajaKopioija,
    private _validationService: FormValidationService,
    private _errorHandler: ErrorHandler,
    private _ladataanService: LadataanService,
    private _asiakasService: AsiakasService,
    private _dateService: DateService,
    private _stringService: StringService,
    private _firebase: FirebaseLemonator,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _debugService: DebugService,
    private _nakymaOikeusService: NakymaOikeusService,
    private _pushIlmoitusUriService: PushIlmoitusUriService,
  ) {
    this.kayttaja = this._kayttajaKopioija.annaUusiKayttaja(null)
  }

  peruuta() {
    this._router.navigate(['asiakkaat', this.asiakas.avain, 'kayttajat'])
  }

  private _muodostaNaytettavatLaitteet(laitteet: KayttajanLaitteet | null | undefined): NaytettavaLaite[] {
    const rivit = Object.values(laitteet?.laitteet ?? {})
    rivit.sort((a, b) => {
      if (!!a.rekisterointiPoistettu !== !!b.rekisterointiPoistettu) {
        return a.rekisterointiPoistettu ? 1 : -1
      }
      return b.paivitetty.toMillis() - a.paivitetty.toMillis()
    })
    return rivit.map(laite => this._muodostaNaytettavaLaite(laite))
  }

  private _muodostaNaytettavaLaite(laite: KayttajanLaite): NaytettavaLaite {
    const alusta = laite.lahde === 'ios' ? 'iOS' : 'Android'
    const pushOsat = [`Lupa ${laite.lupa ?? 'tuntematon'}`, laite.tokenSaatavilla ? 'token saatu' : 'ei tokenia']
    if (laite.lahde === 'ios' && laite.iosAsetukset?.alert) {
      pushOsat.push(`banneri ${laite.iosAsetukset.alert}`)
    }
    return {
      fid: laite.fid,
      laiteTeksti: [laite.laite?.valmistaja, laite.laite?.malli].filter(osa => !!osa).join(' ') || 'Tuntematon laite',
      alustaTeksti: laite.laite?.kayttojarjestelmaVersio ? `${alusta} ${laite.laite.kayttojarjestelmaVersio}` : alusta,
      sovellusTeksti: laite.sovellus ? `${laite.sovellus.versio} (${laite.sovellus.build})` : '-',
      pushTeksti: pushOsat.join(', '),
      ilmoituksetTeksti: laite.tilaukset?.selvityspyynto === false ? 'Pois' : 'Päällä',
      rekisteroityTeksti: laite.luotu ? this._muotoileAika(laite.luotu) : '-',
      paivitettyTeksti: this._muotoileAika(laite.paivitetty),
      tilaTeksti: laite.rekisterointiPoistettu ? `Rekisteröinti poistettu ${this._muotoileAika(laite.rekisterointiPoistettu)}` : 'Aktiivinen',
      poistettu: !!laite.rekisterointiPoistettu,
    }
  }

  private _muotoileAika(aika: KayttajanLaite['paivitetty']) {
    return this._dateService.muotoilePaivaJaAikaDate(this._dateService.timestampToDate(aika), 'fi')
  }

  save() {
    this.saveInternal('ala-tallenna-taikalinkkia')
  }

  saveTaikalinkki() {
    this.saveInternal('tallenna-taikalinkki')
  }

  async saveInternal(tallennaTaikalinkki: TallennaTaikalinkkiType, poistaHetu?: boolean) {
    if (!this.lomake().valid()) {
      this._validationService.merkitseKokoLomakeKosketuksi(this.lomake)
      return
    }

    if (this.kayttaja.aktiivinen && !this._kayttajaHasAtLeastOneLemonaidRole(this.kayttaja)) {
      const err = document.querySelector('#roolit')
      err?.scrollIntoView({ behavior: 'smooth' })
      this.atLeastOneLemonaidRoleError.set('Lisää vähintään yksi Lemonaid-rooli')
      return
    }

    // Tarkista yhteystietojen muutokset
    const voikoTallentaa = await this._tarkistaYhteystietojenMuutokset()
    if (!voikoTallentaa) {
      return
    }

    let alvPortaatValittu = false
    this.kayttaja.prosessinOsat = []
    for (const osa of this.prosessinOsat) {
      if (osa.valittu) {
        this.kayttaja.prosessinOsat.push(osa.lisaysProsessinOsa)
        if (osa.lisaysProsessinOsa.tunniste === TositteenLisaysprosessinOsanTunniste.ALV_VAHENNYSOIKEUS) {
          alvPortaatValittu = true
        }
      }
    }

    // Suodata pois portaat, jos osa ei valittu
    if (!alvPortaatValittu) {
      this.kayttaja.alvVahennysoikeusPortaat = null
    }

    const tallennaData: TallennaKayttajaPyynto = { asiakasAvain: this.asiakas.avain, kayttaja: this.kayttaja, tallennaTaikalinkki: tallennaTaikalinkki, poistaHetu: poistaHetu }

    if (tallennaTaikalinkki === 'tallenna-taikalinkki' && this.kayttaja.tervetuloaEmailStatus) {
      this._dialog
        .open(KayttajaHaluatkoVarmastiLahettaaTaikalinkinDialog)
        .afterClosed()
        .subscribe(result => {
          if (result === 'yes-please-send') {
            console.log('Tallenna dialogista')
            this._saveIt(tallennaData)
          }
        })
      return
    }

    console.log('Tallenna ilman dialogia')
    this._saveIt(tallennaData)
  }

  private _kayttajaHasAtLeastOneLemonaidRole(kayttaja: Kayttaja) {
    return (
      kayttaja.roolit.LASKUTUS ||
      kayttaja.roolit.TOSITTEET_MYYNTI ||
      kayttaja.roolit.TOSITTEET_OSTO ||
      kayttaja.roolit.TOSITTEET_PALKKA ||
      kayttaja.roolit.TOSITTEET_TILI ||
      kayttaja.roolit.SAHKOISTEN_LASKUJEN_VASTAANOTTO ||
      kayttaja.roolit.PALKAT ||
      kayttaja.roolit.MAKSUT ||
      kayttaja.roolit.MAKSUT_VASTAANOTTAJA ||
      kayttaja.roolit.MAKSUT_MAKSAJA ||
      kayttaja.roolit.MAKSUT_HYVAKSYJA ||
      kayttaja.roolit.TUNNISTETAAN
    ) // TODO! Consider using RAPORTIT instead when the tase, pääkirja tc reports are live in Lemonaid
  }

  private async _tarkistaYhteystietojenMuutokset(): Promise<boolean> {
    const onOlemassaOlevaKayttaja = this.kayttaja?.avain && this._kayttajaAlkuperainenEmail !== undefined
    if (!onOlemassaOlevaKayttaja) {
      return true
    }

    const emailMuuttui = this._kayttajaAlkuperainenEmail !== this.kayttaja.email
    const puhelinMuuttui = this._kayttajaAlkuperainenPuhelin !== this.kayttaja.puhelinnumero

    if (!emailMuuttui && !puhelinMuuttui) {
      return true
    }

    let teksti = ''
    if (emailMuuttui) {
      teksti += `Sähköposti: ${this._kayttajaAlkuperainenEmail} → ${this.kayttaja.email}\n`
    }
    if (puhelinMuuttui) {
      teksti += `Puhelinnumero: ${this._kayttajaAlkuperainenPuhelin} → ${this.kayttaja.puhelinnumero}`
    }
    teksti += '\nKäyttäjälle lähetetään ilmoitus muutoksesta.'

    const dialogData: AreYouSureDialogData = {
      header: 'Haluatko varmasti muuttaa yhteystietoja?',
      rightAction: 'Tallenna',
      leftAction: 'Peruuta',
      text: teksti,
    }

    const vahvistettu = await firstValueFrom(this._dialog.open(AreYouSureDialog, { data: dialogData }).afterClosed())
    return !!vahvistettu
  }

  private _saveIt(tallennaData: TallennaKayttajaPyynto) {
    this.commonError.set(null)

    if (tallennaData.kayttaja.aktiivinen) {
      const rooleja = Object.entries(tallennaData.kayttaja?.roolit ?? {}).filter(([rooli, aktiivinen]) => aktiivinen).length
      if (rooleja < 1) {
        this.commonError.set('Aktiivisella käyttäjällä pitää olla vähintään yksi rooli. (Jollei rooleja ole, ei käyttäjä näe mitään Lemonidissa, vaikka pystyykin kirjautumaan sinne.')
        return
      }
    }

    this._ladataanService.aloitaLataaminen()

    this._firebase
      .functionsCall<TallennaKayttajaPyynto, TallennaKayttajaVastaus>('asiakasKayttajaTallenna', tallennaData)
      .then(result => {
        this._ladataanService.lopetaLataaminen()
        if (!result || result.e) {
          if (result && result.e === 'kayttaja-useassa-yrityksessa') {
            let error = 'Käyttäjä ' + this.kayttaja.etunimi + ' ' + this.kayttaja.sukunimi + ' (' + this.kayttaja.email + ', uid: ' + this.kayttaja.avain + ') on jo lisätty asiakkaisiin:'
            for (const yritys of result.missaYrityksissaKiinni) {
              error += ' ' + yritys.asiakasNimi + ' (' + yritys.asiakasYtunnus + ', id: ' + yritys.asiakasAvain + '),'
            }
            error += ' Sama käyttäjä ei voi olla useammassa asiakkaassa.'
            this.commonError.set(error)
          } else {
            const error = result ? result.e : 'Ei resulttia'
            this.commonError.set('Tallentamisen aikana tapahtui virhe. Ole hyvä ja ilmoita tästä ylläpidolle. Tekninen virhe: "' + error + '".')
          }
        } else {
          this.navigoiTakaisinListaan()
        }
      })
      .catch(err => {
        this._ladataanService.lopetaLataaminen()
        this._errorHandler.handleError(err)
        this.commonError.set('Tallentamisen aikana tapahtui virhe. Ole hyvä ja ilmoita tästä ylläpidolle. Tekninen virhe: "' + err.message + '".')
      })
  }

  maksutapaAlas($event: MouseEvent, index: number) {
    const rivit = [...this.maksutapaRivit().value()]
    if (rivit.length > index + 1) {
      const b = rivit[index]
      rivit[index] = rivit[index + 1]
      rivit[index + 1] = b
      asetaArvo(this.maksutapaRivit, rivit, { ilmoita: false })

      const b2 = this.kayttaja.maksutavat[index]
      this.kayttaja.maksutavat[index] = this.kayttaja.maksutavat[index + 1]
      this.kayttaja.maksutavat[index + 1] = b2

      this.paivitaMaksutapojenJarjestys(this.maksutapaRivit, this.asiakkaanMaksutavat, this.kayttaja)
    }
    $event.stopPropagation()
    $event.preventDefault()
  }

  public maksutapaYlos($event: MouseEvent, index: number) {
    const rivit = [...this.maksutapaRivit().value()]
    if (index - 1 > -1) {
      const b = rivit[index]
      rivit[index] = rivit[index - 1]
      rivit[index - 1] = b
      asetaArvo(this.maksutapaRivit, rivit, { ilmoita: false })

      const b2 = this.kayttaja.maksutavat[index]
      this.kayttaja.maksutavat[index] = this.kayttaja.maksutavat[index - 1]
      this.kayttaja.maksutavat[index - 1] = b2

      this.paivitaMaksutapojenJarjestys(this.maksutapaRivit, this.asiakkaanMaksutavat, this.kayttaja)
    }
    $event.stopPropagation()
    $event.preventDefault()
  }

  public poistaAlvPorras(index: number) {
    this._portaidenLopetukset[index].next()
    this._portaidenLopetukset[index].complete()
    this._portaidenLopetukset.splice(index, 1)
    asetaArvo(
      this._portaat,
      this._portaat()
        .value()
        .filter((_, i) => i !== index),
      { ilmoita: false },
    )
    this.kayttaja.alvVahennysoikeusPortaat.splice(index, 1)
  }

  public lisaaAlvPorras(): FieldTree<AlvPorrasLomake> {
    const onkoOletusJo = this.onkoKayttajallaOletusAlvPorras(this.kayttaja)
    const lisattava: TositteenLisaysprosessinAlvVahennysoikeusPorras = {
      arvo: null,
      oletus: !onkoOletusJo,
    }
    if (!this.kayttaja.alvVahennysoikeusPortaat) {
      this.kayttaja.alvVahennysoikeusPortaat = []
    }

    const rivi = this._lisaaAlvPorrasRivi(lisattava)
    this.kayttaja.alvVahennysoikeusPortaat.push(lisattava)

    if (lisattava.oletus && this._portaatOsa && this._portaatOsa().value().oletusporras !== undefined) {
      const oletusIndex = this.kayttaja.alvVahennysoikeusPortaat.length - 1
      asetaArvo(this._portaatOsa.oletusporras, oletusIndex)
    }
    return rivi
  }

  ylos(index: number) {
    const osat = [...this.lomake.prosessinOsat().value()]
    if (index - 1 > -1) {
      const b = osat[index]
      osat[index] = osat[index - 1]
      osat[index - 1] = b
      asetaArvo(this.lomake.prosessinOsat, osat, { ilmoita: false })

      const b2 = this.prosessinOsat[index]
      this.prosessinOsat[index] = this.prosessinOsat[index - 1]
      this.prosessinOsat[index - 1] = b2
    }
  }

  alas(index: number) {
    const osat = [...this.lomake.prosessinOsat().value()]
    if (osat.length > index + 1) {
      const b = osat[index]
      osat[index] = osat[index + 1]
      osat[index + 1] = b
      asetaArvo(this.lomake.prosessinOsat, osat, { ilmoita: false })

      const b2 = this.prosessinOsat[index]
      this.prosessinOsat[index] = this.prosessinOsat[index + 1]
      this.prosessinOsat[index + 1] = b2
    }
  }

  async pakotaVahvaTunnistautuminenUudelleen() {
    const dialogData: AreYouSureDialogData = {
      rightAction: 'Kyllä',
      leftAction: 'Ei',
      text: 'Oletko varma, että haluat poistaa hetun ja pakottaa käyttäjän tunnistautumaan uudelleen Lemonaidissa?',
    }

    const isSure = await firstValueFrom(this._dialog.open(AreYouSureDialog, { data: dialogData }).afterClosed())

    if (!isSure) {
      return
    }

    if (this.kayttaja?.avain) {
      this.asetaRooli(this.kayttaja, Roolit.TUNNISTETAAN, true)
      this.kayttaja.hetu = null
      this.kayttaja.kayttajaTunnistettu = 'ei-tunnistettu'
      this.saveInternal('ala-tallenna-taikalinkkia', true)
    } else {
      this._errorHandler.handleError(new Error('Käyttäjä puuttuu!!'))
    }
  }

  vaihdaSalasana() {
    if (this.kayttaja?.avain) {
      this._dialog.open(KayttajaVaihdaSalasanaDialog, { data: this.kayttaja })
    } else {
      this._errorHandler.handleError(new Error('Käyttäjä puuttuu!!'))
    }
  }

  kirjauduKayttajana() {
    if (this.kayttaja && this.kayttaja.avain && this.asiakas && this.asiakas.avain) {
      this._ladataanService.aloitaLataaminen()
      const pyynto: AloitaKayttajanaKirjautuminenPyynto = {
        asiakasAvain: this.asiakas.avain,
        kayttajaAvain: this.kayttaja.avain,
      }
      this._firebase
        .functionsCall<AloitaKayttajanaKirjautuminenPyynto, void>('kirjautuminenKayttajanaAloita', pyynto)
        .then(() => {
          this._ladataanService.lopetaLataaminen()
        })
        .catch(error => {
          this._ladataanService.lopetaLataaminen()
          this._errorHandler.handleError(error)
        })
    } else {
      this._errorHandler.handleError(new Error('Asiakas tai käyttäjä puuttuu!! ' + this.asiakas + ' | ' + this.kayttaja))
    }
  }
  async naytaLoginHistoriaa() {
    let loginHistoria: LoginInformation[] = []
    if (this.kayttaja?.avain) {
      loginHistoria = await this._firebaseLemonaid
        .firestoreCollection<LoginInformation>('customers/' + this.asiakas.avain + '/customers-users/' + this.kayttaja.avain + '/user-logins/')
        .orderBy('timestamp', 'desc')
        .limit(100)
        .get()
        .then(snapshots => {
          const output: LoginInformation[] = []
          for (const snap of snapshots) {
            output.push(snap)
          }
          return output
        })
    }
    this._dialog.open(KayttajaLoginHistoryDialog, { data: loginHistoria })
  }

  ngAfterContentChecked() {
    this.fieldErrors = this._validationService.updateValidationStatus('asiakas', this.lomake)
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

  ngOnInit() {
    // Debug thingies
    this.kirjanpitajaOnDevaajaObservable = this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaObservable
    this.kirjanpitajaOnLuottoObservable = this._kirjautunutKayttajaService.kirjanpitajaOnLuottoObservable
    this.kayttajaUriObservable = combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasAvainObservable]).pipe(
      map(([route, avainTiedot]: [{ data: KayttajaComponentData }, AsiakkaanAvainTiedot]) => {
        if (avainTiedot?.avain && route?.data?.kayttaja?.avain) {
          return 'asiakkaat/' + avainTiedot.avain + '/kayttajat/' + route.data.kayttaja.avain
        }
        return ''
      }),
    )
    this.kayttajaEncodedUriObservable = this.kayttajaUriObservable.pipe(
      map(uri => {
        return this._debugService.createFirestoreLink(uri)
      }),
    )
    this.sopimustenHyvaksynnatUriObservable = combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasAvainObservable]).pipe(
      map(([route, avainTiedot]: [{ data: KayttajaComponentData }, AsiakkaanAvainTiedot]) => {
        if (avainTiedot?.avain && route?.data?.kayttaja?.avain) {
          return 'customers/' + avainTiedot.avain + '/customers-users/' + route.data.kayttaja.avain + '/sopimus-hyvaksynnat/'
        }
        return ''
      }),
    )
    this.sopimustenHyvaksynnatEncodedUriObservable = this.sopimustenHyvaksynnatUriObservable.pipe(
      map(uri => {
        return this._debugService.createFirestoreLinkLemonaid(uri)
      }),
    )
    this.lahetetytViestitUriObservable = this._asiakasService.nykyinenAsiakasAvainObservable.pipe(
      map(avainTiedot => (avainTiedot?.avain ? 'customers/' + avainTiedot.avain + '/customers-lahetetyt-viestit' : '')),
    )
    this.lahetetytViestitEncodedUriObservable = this.lahetetytViestitUriObservable.pipe(map(uri => this._debugService.createFirestoreLinkLemonaid(uri)))

    this._kirjautunutKayttajaService.kirjanpitajanAnnetaanMuokataMitaTahansaKirjauksiaObservable.pipe(takeUntil(this.ngUnsubscribe)).subscribe(isAdmin => {
      this.isAdmin.set(isAdmin)
    })

    this.lomake = form(
      signal<KayttajaLomake>({
        ...TYHJA_LOMAKE,
        asiointikieli: '',
        TOSITTEET: false,
        [Roolit.TOSITTEET_MYYNTI]: false,
        [Roolit.TOSITTEET_OSTO]: false,
        [Roolit.TOSITTEET_PALKKA]: false,
        [Roolit.TOSITTEET_TILI]: false,
        [Roolit.SAHKOISTEN_LASKUJEN_VASTAANOTTO]: false,
        [Roolit.PALKAT]: false,
        [Roolit.MAKSUT]: false,
        [Roolit.MAKSUT_VASTAANOTTAJA]: false,
        [Roolit.MAKSUT_MAKSAJA]: false,
        [Roolit.MAKSUT_HYVAKSYJA]: false,
        [Roolit.RAPORTIT]: false,
        [Roolit.HALLINTO_VIIA_VALTUUTUKSEN_ANTAJA]: false,
        [Roolit.HALLINTO_SOPIMUKSEN_HYVAKSYJA]: false,
        [Roolit.HALLINTO_YHTEYSHENKILO]: false,
        [Roolit.HALLINTO_TUNTEMISTIETOJEN_ANTAJA]: false,
        [Roolit.TUNNISTETAAN]: false,
        [UserFeature.CAN_EDIT_PENALTY_INTEREST]: false,
      }),
      polku => {
        required(polku.etunimi)
        required(polku.sukunimi)
        required(polku.asiointikieli)
        required(polku.email)
        validoiReaktiivisesti(polku.email, ctrl => this.validateEmail(ctrl))
        validoiReaktiivisesti(polku.email, ctrl => this.duplicateEmailsValidator(ctrl))
        validoiReaktiivisesti(polku.puhelin, FormValidators.phoneNumberValidator)
        required(polku.selvitettavienNakyvyys)
        disabled(polku.TOSITTEET)
        disabled(polku.MAKSUT)
        applyEach(polku.prosessinOsat, osa => {
          required(osa.otsikko)
          applyEach(osa.alvPortaat, porras => {
            required(porras.arvo)
          })
          required(osa.oletusporras)
        })
      },
      { injector: this._injector },
    )
    const muutokset = <T>(kentta: FieldTree<T>) => arvonMuutokset(kentta, { injector: this._injector })

    // Bind to changes
    muutokset(this.lomake.etunimi).subscribe(value => {
      this.kayttaja.etunimi = this._validationService.processValue(value)
    })
    muutokset(this.lomake.sukunimi).subscribe(value => {
      this.kayttaja.sukunimi = this._validationService.processValue(value)
    })
    muutokset(this.lomake.email).subscribe(value => {
      this.kayttaja.email = this._validationService.processValue(value)
    })
    muutokset(this.lomake.puhelin).subscribe(value => this._puhelinMuuttui(value))
    muutokset(this.lomake.aktiivinen).subscribe(value => {
      this.kayttaja.aktiivinen = this._validationService.processValue(value)
    })
    muutokset(this.lomake.selvitettavienNakyvyys).subscribe(value => {
      this.kayttaja.selvitettavienNakyvyys = this._validationService.processValue(value)
    })
    muutokset(this.lomake.asiointikieli).subscribe(value => {
      this.kayttaja.asiointikieli = this._validationService.processValue(value)
    })

    this.otsikkoObservable = combineLatest([muutokset(this.lomake.etunimi), muutokset(this.lomake.sukunimi)]).pipe(
      map(([etunimi, sukunimi]) => {
        const e = this._validationService.processValue(etunimi)
        const s = this._validationService.processValue(sukunimi)
        if (e || s) {
          return this._stringService.normalizeWhitespace((s || '') + ' ' + (e || '')).trim()
        }
        return ''
      }),
    )

    // Bind roolit begins
    muutokset(this.lomake.LASKUTUS).subscribe(value => {
      if (value) {
        this.atLeastOneLemonaidRoleError.set(null)
      }
      this.asetaRooli(this.kayttaja, Roolit.LASKUTUS, value)
    })

    muutokset(this.lomake.TOSITTEET).subscribe(value => {
      if (value) {
        this.atLeastOneLemonaidRoleError.set(null)
      }
    })
    muutokset(this.lomake.TOSITTEET_MYYNTI).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.TOSITTEET_MYYNTI, value)
      this.asetaTositteetRooli(this.kayttaja)
    })
    muutokset(this.lomake.TOSITTEET_OSTO).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.TOSITTEET_OSTO, value)
      this.asetaTositteetRooli(this.kayttaja)
    })
    muutokset(this.lomake.TOSITTEET_PALKKA).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.TOSITTEET_PALKKA, value)
      this.asetaTositteetRooli(this.kayttaja)
    })
    muutokset(this.lomake.TOSITTEET_TILI).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.TOSITTEET_TILI, value)
      this.asetaTositteetRooli(this.kayttaja)
    })
    muutokset(this.lomake.SAHKOISTEN_LASKUJEN_VASTAANOTTO).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.SAHKOISTEN_LASKUJEN_VASTAANOTTO, value)
      this.asetaTositteetRooli(this.kayttaja)
    })

    muutokset(this.lomake.PALKAT).subscribe(value => {
      if (value) {
        this.atLeastOneLemonaidRoleError.set(null)
      }
      this.asetaRooli(this.kayttaja, Roolit.PALKAT, value)
    })

    muutokset(this.lomake.MAKSUT).subscribe(value => {
      if (value) {
        this.atLeastOneLemonaidRoleError.set(null)
      }
      this.asetaRooli(this.kayttaja, Roolit.MAKSUT, value)
    })

    muutokset(this.lomake.MAKSUT_VASTAANOTTAJA).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.MAKSUT_VASTAANOTTAJA, value)
      this.asetaMaksutRooli(this.kayttaja)
    })
    muutokset(this.lomake.MAKSUT_MAKSAJA).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.MAKSUT_MAKSAJA, value)
      this.asetaMaksutRooli(this.kayttaja)
    })
    muutokset(this.lomake.MAKSUT_HYVAKSYJA).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.MAKSUT_HYVAKSYJA, value)
      this.asetaMaksutRooli(this.kayttaja)
    })

    muutokset(this.lomake.RAPORTIT).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.RAPORTIT, value)
    })

    muutokset(this.lomake.HALLINTO_VIIA_VALTUUTUKSEN_ANTAJA).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.HALLINTO_VIIA_VALTUUTUKSEN_ANTAJA, value)
    })
    muutokset(this.lomake.HALLINTO_SOPIMUKSEN_HYVAKSYJA).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.HALLINTO_SOPIMUKSEN_HYVAKSYJA, value)
    })
    // this.form.get(Roolit.HALLINTO_SUOMI_FI_VALTUUTUKSEN_ANTAJA).valueChanges.subscribe(value => { this.asetaRooli(this.kayttaja, Roolit.HALLINTO_SUOMI_FI_VALTUUTUKSEN_ANTAJA, value) })
    muutokset(this.lomake.HALLINTO_YHTEYSHENKILO).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.HALLINTO_YHTEYSHENKILO, value)
      // Raportit-rooli laitetaan automaattisesti päälle, jos valitaan yhteyshenkilö-rooli ja poistetaan jos yhteyshenkilörooli poistetaan. Raportit-roolin voi edelleen valita silti erikseen.
      asetaArvo(this.lomake.RAPORTIT, value)
    })
    muutokset(this.lomake.HALLINTO_TUNTEMISTIETOJEN_ANTAJA).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.HALLINTO_TUNTEMISTIETOJEN_ANTAJA, value)
    })

    muutokset(this.lomake.TUNNISTETAAN).subscribe(value => {
      this.asetaRooli(this.kayttaja, Roolit.TUNNISTETAAN, value)
    })

    muutokset(this.lomake.CAN_EDIT_PENALTY_INTEREST).subscribe(value => {
      this.asetaFeature(this.kayttaja, UserFeature.CAN_EDIT_PENALTY_INTEREST, value)
    })

    combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasObservable, this._asiakasService.nykyisenAsiakkaanMaksutavatObservable])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(results => {
        const all = results[0] as { data: KayttajaComponentData }
        this.asiakas = results[1]
        this.asiakkaanMaksutavat = results[2] ? [].concat(results[2]) : []
        this._changeDetectorRef.markForCheck()

        this.nollaaLomake()

        if (!all.data.kayttaja) {
          return
        }

        this.kayttaja = this._kayttajaKopioija.kopioiKayttaja(all.data.kayttaja)
        if (!this.kayttaja.roolit) {
          this.kayttaja.roolit = {}
        }
        this._muidenKayttajienEmailit = all.data.muidenKayttajienEmailit

        this.alustaLomakkeenTiedot(this.kayttaja, this.asiakkaanMaksutavat)
        setTimeout(() => {
          if (this.etunimiInput) {
            this.etunimiInput.focus()
            this._changeDetectorRef.markForCheck()
          }
        }, 25)
      })

    const lastLoginInformationObservable: Observable<LoginInformation> = combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasObservable]).pipe(
      switchMap(([routeData, asiakas]) => {
        const all = routeData as { data: KayttajaComponentData }
        const kayttaja: Kayttaja = all.data.kayttaja
        if (kayttaja && asiakas && kayttaja.avain) {
          return this._firebaseLemonaid
            .firestoreCollection<LoginInformation>('customers/' + asiakas.avain + '/customers-users/' + kayttaja.avain + '/user-logins/')
            .orderBy('timestamp', 'desc')
            .limit(1)
            .listen()
            .pipe(
              map(list => {
                return list && list.length > 0 ? list[0] : null
              }),
            )
        }
        return of<LoginInformation>(null)
      }),
    )
    this.lastMagicLinkSendObservable = combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasObservable]).pipe(
      switchMap(([routeData, asiakas]) => {
        const all = routeData as { data: KayttajaComponentData }
        const kayttaja: Kayttaja = all.data.kayttaja
        if (kayttaja && asiakas && kayttaja.avain) {
          return this._firebase
            .firestoreCollection<TaikalinkkiLahetysHistoria>('asiakkaat/' + asiakas.avain + '/kayttajat/' + kayttaja.avain + '/taikalinkki-lahetys-historia/')
            .orderBy('pvm', 'desc')
            .limit(1)
            .listen()
            .pipe(
              map(list => {
                return list && list.length > 0 ? list[0] : null
              }),
            )
        }
        return of<TaikalinkkiLahetysHistoria>(null)
      }),
    )
    this.moniyritystukiNakymaObservable = combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasObservable]).pipe(
      switchMap(([routeData, asiakas]) => {
        const all = routeData as { data: KayttajaComponentData }
        const kayttaja: Kayttaja = all.data.kayttaja
        if (!kayttaja?.avain || !kayttaja.moniyritystukiAvain || !asiakas) {
          return of<MoniyritystukiNakyma>(null)
        }
        const replikaUri = 'asiakkaat/' + asiakas.avain + '/kayttajat/' + kayttaja.avain + '/moniyritystuki/' + kayttaja.moniyritystukiAvain
        return this._firebase
          .firestoreDoc<MoniyritystuenReplika>(replikaUri)
          .listen()
          .pipe(map(tuki => ({ tukiAvain: kayttaja.moniyritystukiAvain, kayttajaAvain: kayttaja.avain, replikaUri: replikaUri, tuki: tuki ?? null })))
      }),
    )
    this.moniyritystukiEncodedUriObservable = this.moniyritystukiNakymaObservable.pipe(map(nakyma => (nakyma ? this._debugService.createFirestoreLink(nakyma.replikaUri) : '')))
    this.naytaMoniyritystukiLinkkiObservable = combineLatest([this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaTaiTukiObservable, this._nakymaOikeusService.sallitutNakymatObservable]).pipe(
      map(([onDevaajaTaiTuki, sallitutNakymat]) => onDevaajaTaiTuki && !!sallitutNakymat?.[LemonatorNakyma.YLLAPITO_MONIYRITYSTUET]),
    )

    this.lastLoginObservable = lastLoginInformationObservable.pipe(
      map(info => {
        if (info) {
          // Aika
          let retVal = this._dateService.muotoilePaivaJaAikaDate(this._dateService.timestampToDate(info.timestamp), 'fi')

          // Ympäristö
          if (info.ymparisto === 'a') {
            retVal += ' Android'
          } else if (info.ymparisto === 'i') {
            retVal += ' iOS'
          } else if (info.ymparisto === 'w') {
            retVal += ' Web'
          } else {
            retVal += ' tuntematon ympäristö'
          }

          // Ympäristön softaversio
          retVal += ' ' + info.version

          // Laite jolla käytettiin
          // retVal += ' ' + info.device
          // retVal += ' ' + info.os

          return retVal
        }
        return 'Ei vielä kirjautunut'
      }),
    )

    this.luvatJaSopimuksetObservable = combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasObservable]).pipe(
      switchMap(([routeData, asiakas]) => {
        const all = routeData as { data: KayttajaComponentData }
        const kayttaja: Kayttaja = all.data.kayttaja
        if (kayttaja && asiakas) {
          const output: LuvatJaSopimukset = {
            asiakasLuotu: this._dateService.muotoilePaivaJaAikaDate(asiakas.luotu.toDate(), 'fi'),
            kayttajaLuotu: this._dateService.muotoilePaivaJaAikaDate(kayttaja.luotu.toDate(), 'fi'),
            hetu: kayttaja.hetu,
            tunnistamisStatus: kayttaja.kayttajaTunnistettu,
          }
          return of<LuvatJaSopimukset>(output)
        }
        return of<LuvatJaSopimukset>(null)
      }),
    )
    this.sopimuksienHyvaksynnatObservable = combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasObservable]).pipe(
      switchMap(([routeData, asiakas]) => {
        const all = routeData as { data: KayttajaComponentData }
        const kayttaja: Kayttaja = all.data.kayttaja
        if (kayttaja && kayttaja.avain && asiakas) {
          return this._firebaseLemonaid
            .firestoreCollection<SopimuksenHyvaksynnanHistoria>('customers/' + asiakas.avain + '/customers-users/' + kayttaja.avain + '/sopimus-hyvaksynnat/')
            .listen()
            .pipe(
              map(docs => {
                if (docs || docs.length) {
                  return docs
                }
                return null
              }),
            )
        }
        return of(null)
      }),
    )
    this.laitteetObservable = combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasObservable]).pipe(
      switchMap(([routeData, asiakas]) => {
        const all = routeData as { data: KayttajaComponentData }
        const kayttaja: Kayttaja = all.data.kayttaja
        if (!kayttaja?.avain || !asiakas) {
          return of<NaytettavaLaite[]>([])
        }
        return this._firebaseLemonaid
          .firestoreDoc<KayttajanLaitteet>(this._pushIlmoitusUriService.annaKayttajanLaitteetUri(asiakas.avain, kayttaja.avain))
          .listen()
          .pipe(map(laitteet => this._muodostaNaytettavatLaitteet(laitteet)))
      }),
    )
    const lahetetytViestitRaakaObservable = combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasObservable, this._lahetetytViestitLimitSubject]).pipe(
      switchMap(([routeData, asiakas, limit]) => {
        const all = routeData as { data: KayttajaComponentData }
        const kayttaja: Kayttaja = all.data.kayttaja
        if (!kayttaja?.avain || !asiakas) {
          return of<{ viestit: (LahetettySahkoposti | LahetettySms)[]; kayttajaAvain: string }>({ viestit: [], kayttajaAvain: null })
        }
        return this._firebaseLemonaid
          .firestoreCollection<LahetettySahkoposti | LahetettySms>(`customers/${asiakas.avain}/customers-lahetetyt-viestit`)
          .orderBy('sent', 'desc')
          .limit(limit)
          .listen()
          .pipe(map(viestit => ({ viestit, kayttajaAvain: kayttaja.avain })))
      }),
    )
    this.lahetetytViestitObservable = lahetetytViestitRaakaObservable.pipe(
      map(({ viestit, kayttajaAvain }) =>
        viestit
          .filter(v => {
            if (!kayttajaAvain || !v.kayttajaAvain) {
              return false
            }
            return Array.isArray(v.kayttajaAvain) ? v.kayttajaAvain.includes(kayttajaAvain) : v.kayttajaAvain === kayttajaAvain
          })
          .map(v => this._muodostaLahetettyViestiRivi(v)),
      ),
    )
    this.naytaLisaaLahetettyjaViestejaObservable = combineLatest([lahetetytViestitRaakaObservable, this._lahetetytViestitLimitSubject]).pipe(map(([{ viestit }, limit]) => viestit.length >= limit))
  }

  naytaLisaaLahetettyjaViesteja() {
    this._lahetetytViestitLimitSubject.next(this._lahetetytViestitLimitSubject.value + KayttajaComponent.LAHETETYT_VIESTIT_SIVUKOKO)
  }

  private _muodostaLahetettyViestiRivi(v: LahetettySahkoposti | LahetettySms): LahetettyViestiRivi {
    const teksti = v.messageType === 'email' ? v.messageText : v.message
    const esikatselu = teksti.length > 80 ? teksti.substring(0, 80).trim() + '…' : teksti
    return {
      avain: v.avain,
      pvm: this._dateService.muotoilePaivaJaAikaDate(v.sent.toDate(), 'fi'),
      tyyppiTeksti: v.type,
      kanavaTeksti: v.messageType === 'email' ? 'Sähköposti' : 'SMS',
      vastaanottaja: v.messageType === 'email' ? v.recipients.map(r => r.email).join(', ') : v.numbers.join(', '),
      esikatselu,
      sisaltoText: teksti,
      naytaSisalto: false,
    }
  }

  private asetaRooli(kayttaja: Kayttaja, rooli: Roolit, value: boolean) {
    if (value) {
      kayttaja.roolit[rooli] = true
    } else {
      kayttaja.roolit[rooli] = false // firebase.firestore.FieldValue.delete() as any
    }
  }

  private asetaFeature(kayttaja: Kayttaja, feature: UserFeature, value: boolean) {
    if (value) {
      if (!kayttaja.features) {
        kayttaja.features = {}
      }
      kayttaja.features[feature] = true
    } else {
      if (kayttaja.features) {
        kayttaja.features[feature] = false
      }
    }
  }

  private validateEmail: ValidatorFn = (ctrl: AbstractControl): ValidationErrors | null => {
    if (ctrl.value == null || ctrl.value === undefined || ctrl.value.trim() === '') {
      return null
    }
    return Validators.email(ctrl)
  }

  private duplicateEmailsValidator: ValidatorFn = (ctrl: AbstractControl): ValidationErrors | null => {
    if (ctrl.value == null || ctrl.value === undefined || ctrl.value.trim() === '') {
      return null
    }
    if (this._muidenKayttajienEmailit.includes(ctrl.value?.trim())) {
      return { emailinuse: true }
    }
    return null
  }

  private nollaaLomake() {
    this._prosessinOsienLopetus.next()
    this._prosessinOsienLopetus.complete()
    this._prosessinOsienLopetus = new Subject<void>()
    asetaArvo(this.lomake.prosessinOsat, [], { ilmoita: false })
    nollaa(this.lomake, TYHJA_LOMAKE)
  }

  private _puhelinMuuttui(value: string | null | undefined) {
    this.kayttaja.puhelinnumero = this._validationService.processValue(value)
  }

  private asetaTositteetRooli(kayttaja: Kayttaja) {
    asetaArvo(
      this.lomake.TOSITTEET,
      RooliMapper.annaBooleanArvo(kayttaja.roolit.TOSITTEET_MYYNTI) ||
        RooliMapper.annaBooleanArvo(kayttaja.roolit.TOSITTEET_OSTO) ||
        RooliMapper.annaBooleanArvo(kayttaja.roolit.TOSITTEET_PALKKA) ||
        RooliMapper.annaBooleanArvo(kayttaja.roolit.TOSITTEET_TILI) ||
        RooliMapper.annaBooleanArvo(kayttaja.roolit.SAHKOISTEN_LASKUJEN_VASTAANOTTO),
    )
  }

  private asetaMaksutRooli(kayttaja: Kayttaja) {
    asetaArvo(
      this.lomake.MAKSUT,
      RooliMapper.annaBooleanArvo(kayttaja.roolit.MAKSUT_MAKSAJA) || RooliMapper.annaBooleanArvo(kayttaja.roolit.MAKSUT_HYVAKSYJA) || RooliMapper.annaBooleanArvo(kayttaja.roolit.MAKSUT_VASTAANOTTAJA),
    )
  }

  private alustaLomakkeenTiedot(kayttaja: Kayttaja, maksutavat: AsiakkaanMaksutapa[]) {
    // Basic data
    asetaArvo(this.lomake.etunimi, kayttaja.etunimi ?? '')
    asetaArvo(this.lomake.sukunimi, kayttaja.sukunimi ?? '')
    asetaArvo(this.lomake.email, kayttaja.email ?? '')
    // Puuttuva puhelinnumero välitetään sellaisenaan, koska tekstikentän arvo ei voi olla null
    asetaArvo(this.lomake.puhelin, kayttaja.puhelinnumero ?? '', { ilmoita: false })
    this._puhelinMuuttui(kayttaja.puhelinnumero)
    asetaArvo(this.lomake.aktiivinen, kayttaja.aktiivinen ?? null)
    asetaArvo(this.lomake.selvitettavienNakyvyys, kayttaja.selvitettavienNakyvyys ?? null)
    asetaArvo(this.lomake.asiointikieli, kayttaja.asiointikieli ? kayttaja.asiointikieli : 'fi')

    // Roles
    asetaArvo(this.lomake.LASKUTUS, RooliMapper.annaBooleanArvo(kayttaja.roolit.LASKUTUS))

    this.asetaTositteetRooli(kayttaja)
    // this.form.get('TOSITTEET').setValue(RooliMapper.annaBooleanArvo(kayttaja.roolit.TOSITTEET))
    asetaArvo(this.lomake.TOSITTEET_MYYNTI, RooliMapper.annaBooleanArvo(kayttaja.roolit.TOSITTEET_MYYNTI))
    asetaArvo(this.lomake.TOSITTEET_OSTO, RooliMapper.annaBooleanArvo(kayttaja.roolit.TOSITTEET_OSTO))
    asetaArvo(this.lomake.TOSITTEET_PALKKA, RooliMapper.annaBooleanArvo(kayttaja.roolit.TOSITTEET_PALKKA))
    asetaArvo(this.lomake.TOSITTEET_TILI, RooliMapper.annaBooleanArvo(kayttaja.roolit.TOSITTEET_TILI))
    asetaArvo(this.lomake.SAHKOISTEN_LASKUJEN_VASTAANOTTO, RooliMapper.annaBooleanArvo(kayttaja.roolit.SAHKOISTEN_LASKUJEN_VASTAANOTTO))

    asetaArvo(this.lomake.PALKAT, RooliMapper.annaBooleanArvo(kayttaja.roolit.PALKAT))

    asetaArvo(
      this.lomake.MAKSUT,
      RooliMapper.annaBooleanArvo(kayttaja.roolit.MAKSUT_VASTAANOTTAJA) ||
        RooliMapper.annaBooleanArvo(kayttaja.roolit.MAKSUT_MAKSAJA) ||
        RooliMapper.annaBooleanArvo(kayttaja.roolit.MAKSUT_HYVAKSYJA) ||
        RooliMapper.annaBooleanArvo(kayttaja.roolit.MAKSUT),
    )
    asetaArvo(this.lomake.MAKSUT_VASTAANOTTAJA, RooliMapper.annaBooleanArvo(kayttaja.roolit.MAKSUT_VASTAANOTTAJA))
    asetaArvo(this.lomake.MAKSUT_MAKSAJA, RooliMapper.annaBooleanArvo(kayttaja.roolit.MAKSUT_MAKSAJA))
    asetaArvo(this.lomake.MAKSUT_HYVAKSYJA, RooliMapper.annaBooleanArvo(kayttaja.roolit.MAKSUT_HYVAKSYJA))

    asetaArvo(this.lomake.RAPORTIT, RooliMapper.annaBooleanArvo(kayttaja.roolit.RAPORTIT))

    asetaArvo(this.lomake.HALLINTO_VIIA_VALTUUTUKSEN_ANTAJA, RooliMapper.annaBooleanArvo(kayttaja.roolit.HALLINTO_VIIA_VALTUUTUKSEN_ANTAJA))
    asetaArvo(this.lomake.HALLINTO_SOPIMUKSEN_HYVAKSYJA, RooliMapper.annaBooleanArvo(kayttaja.roolit.HALLINTO_SOPIMUKSEN_HYVAKSYJA))
    // this.form.get(Roolit.HALLINTO_SUOMI_FI_VALTUUTUKSEN_ANTAJA).setValue(RooliMapper.annaBooleanArvo(kayttaja.roolit.HALLINTO_SUOMI_FI_VALTUUTUKSEN_ANTAJA))

    /**
     * HALLINTO_YHTEYSHENKILO täppä ohjaa myös RAPORTIT-täppää. Käytetään alustaessa emitEvent: false, jottei poisteta käyttäjän mahdollista
     * RAPORTIT-roolia tai lisätä sitä ilman käyttäjän interaktioita alustaessa lomakkeen arvoja (kts. valueChanges-kuuntelija).
     *  */
    asetaArvo(this.lomake.HALLINTO_YHTEYSHENKILO, RooliMapper.annaBooleanArvo(kayttaja.roolit.HALLINTO_YHTEYSHENKILO), { ilmoita: false })
    asetaArvo(this.lomake.HALLINTO_TUNTEMISTIETOJEN_ANTAJA, RooliMapper.annaBooleanArvo(kayttaja.roolit.HALLINTO_TUNTEMISTIETOJEN_ANTAJA))

    asetaArvo(this.lomake.TUNNISTETAAN, RooliMapper.annaBooleanArvo(kayttaja.roolit.TUNNISTETAAN))

    asetaArvo(this.lomake.CAN_EDIT_PENALTY_INTEREST, !!kayttaja?.features?.CAN_EDIT_PENALTY_INTEREST)

    // Tallennetaan alkuperäiset yhteystiedot muutosten tarkistusta varten
    this._kayttajaAlkuperainenEmail = kayttaja.email
    this._kayttajaAlkuperainenPuhelin = kayttaja.puhelinnumero

    // Lemonaid cell phone process
    this.prosessinOsat = this.annaProsessienOsat(this.kayttaja)
    this._lisaaProsessinOsatLomakkeelle(this.prosessinOsat, kayttaja, maksutavat)
  }

  private _lisaaMaksutavat(osaRivi: FieldTree<ProsessinOsaLomake>, kayttaja: Kayttaja, maksutavat: AsiakkaanMaksutapa[]) {
    asetaArvo(osaRivi, { ...osaRivi().value(), maksutavat: [] }, { ilmoita: false })
    this.maksutapaRivit = osaRivi.maksutavat
    this._maksutapojenLopetus = new Subject<void>()
    if (maksutavat) {
      for (const maksutapa of maksutavat) {
        this._lisaaMaksutapaValinta(kayttaja, maksutapa, maksutavat)
      }
      this.paivitaMaksutapojenJarjestys(this.maksutapaRivit, maksutavat, kayttaja)
    }
  }

  private _poistaMaksutavat(osaRivi: FieldTree<ProsessinOsaLomake>) {
    this._maksutapojenLopetus.next()
    this._maksutapojenLopetus.complete()
    this.maksutapaRivit = null
    asetaArvo(osaRivi, { ...osaRivi().value(), maksutavat: undefined }, { ilmoita: false })
  }

  private paivitaMaksutapojenJarjestys(maksutapaRivit: FieldTree<MaksutapaValintaLomake[]>, maksutavat: AsiakkaanMaksutapa[], kayttaja: Kayttaja) {
    maksutavat.sort((a, b) => {
      if (kayttaja.maksutavat) {
        const indexOfA = kayttaja.maksutavat.indexOf(a.tunniste)
        const indexOfB = kayttaja.maksutavat.indexOf(b.tunniste)
        if (indexOfA > -1 && indexOfB > -1) {
          return indexOfA - indexOfB
        }
        if (indexOfA > -1) {
          return -1
        }
        if (indexOfB > -1) {
          return 1
        }
      }
      return b.tunniste - a.tunniste
    })
    const jarjestetytRivit = [...maksutapaRivit().value()].sort((a, b) => {
      const tunnisteA = a.tunniste
      const tunnisteB = b.tunniste
      if (kayttaja.maksutavat) {
        const indexOfA = kayttaja.maksutavat.indexOf(tunnisteA)
        const indexOfB = kayttaja.maksutavat.indexOf(tunnisteB)
        if (indexOfA > -1 && indexOfB > -1) {
          return indexOfA - indexOfB
        }
        if (indexOfA > -1) {
          return -1
        }
        if (indexOfB > -1) {
          return 1
        }
      }
      return tunnisteB - tunnisteA
    })
    asetaArvo(maksutapaRivit, jarjestetytRivit, { ilmoita: false })
    this.aktivoitujenMaksutapojenLukumaara = kayttaja.maksutavat ? kayttaja.maksutavat.length : 0
  }

  private _lisaaMaksutapaValinta(kayttaja: Kayttaja, maksutapa: AsiakkaanMaksutapa, maksutavat: AsiakkaanMaksutapa[]) {
    const kaytossa = kayttaja.maksutavat
      ? kayttaja.maksutavat.reduce<boolean>((previousValue, currentValue, currentIndex, array) => {
          return previousValue || currentValue === maksutapa.tunniste
        }, false)
      : false
    const rivit = this.maksutapaRivit().value()
    asetaArvo(this.maksutapaRivit, [...rivit, { kaytossa, tunniste: maksutapa.tunniste }], { ilmoita: false })
    arvonMuutokset(this.maksutapaRivit[rivit.length].kaytossa, { injector: this._injector })
      .pipe(takeUntil(this._maksutapojenLopetus), takeUntil(this._prosessinOsienLopetus))
      .subscribe(value => {
        if (kayttaja.maksutavat) {
          const index = kayttaja.maksutavat.indexOf(maksutapa.tunniste)
          if (value && index < 0) {
            kayttaja.maksutavat.push(maksutapa.tunniste)
          } else if (!value && index > -1) {
            kayttaja.maksutavat.splice(index, 1)
          }
        } else if (value) {
          kayttaja.maksutavat = []
          kayttaja.maksutavat.push(maksutapa.tunniste)
        }
        this.paivitaMaksutapojenJarjestys(this.maksutapaRivit, maksutavat, kayttaja)
      })
  }

  private onkoKayttajallaOletusAlvPorras(kayttaja: Kayttaja): boolean {
    if (kayttaja && kayttaja.alvVahennysoikeusPortaat) {
      for (const porras of kayttaja.alvVahennysoikeusPortaat) {
        if (porras.oletus) {
          return true
        }
      }
    }
    return false
  }

  private _lisaaProsessinOsatLomakkeelle(prosessinOsat: MuokkausprosessinOsa[], kayttaja: Kayttaja, maksutavat: AsiakkaanMaksutapa[]) {
    for (const osa of prosessinOsat) {
      this._lisaaProsessinOsa(osa, kayttaja, maksutavat)
    }
  }

  private _lisaaAlvPorrasRivi(porras: TositteenLisaysprosessinAlvVahennysoikeusPorras): FieldTree<AlvPorrasLomake> {
    const portaat = this._portaat().value()
    asetaArvo(this._portaat, [...portaat, { arvo: porras.arvo ?? null, oletus: porras.oletus ?? null }], { ilmoita: false })
    const rivi = this._portaat[portaat.length]
    const lopetus = new Subject<void>()
    this._portaidenLopetukset.push(lopetus)
    const muutokset = <T>(kentta: FieldTree<T>) => arvonMuutokset(kentta, { injector: this._injector }).pipe(takeUntil(lopetus), takeUntil(this._prosessinOsienLopetus))
    muutokset(rivi.arvo).subscribe(value => {
      porras.arvo = this._validationService.processValue(value)
    })
    muutokset(rivi.oletus).subscribe(value => {
      porras.oletus = this._validationService.processValue(value)
    })
    return rivi
  }

  // 'alvPortaat': new FormControl('', [ Validators.required ] ),
  private lisaaAlvPortaat(kayttaja: Kayttaja): number {
    if (!kayttaja?.alvVahennysoikeusPortaat?.length) {
      const firstGroup = this.lisaaAlvPorras()
      const secondGroup = this.lisaaAlvPorras()
      const thirdGroup = this.lisaaAlvPorras()
      asetaArvo(firstGroup.arvo, 0)
      asetaArvo(firstGroup.oletus, false)
      asetaArvo(secondGroup.arvo, 50)
      asetaArvo(secondGroup.oletus, true)
      asetaArvo(thirdGroup.arvo, 100)
      asetaArvo(thirdGroup.oletus, false)
    } else {
      for (const porras of kayttaja.alvVahennysoikeusPortaat) {
        this._lisaaAlvPorrasRivi(porras)
      }
    }
    let oletus = 0,
      index = 0
    for (const porras of kayttaja.alvVahennysoikeusPortaat) {
      if (porras.oletus) {
        oletus = index
      }
      index++
    }
    return oletus
  }

  private lisaaAlvPortaatJaOletus(osaRivi: FieldTree<ProsessinOsaLomake>, kayttaja: Kayttaja) {
    asetaArvo(osaRivi, { ...osaRivi().value(), alvPortaat: [] }, { ilmoita: false })
    this._portaat = osaRivi.alvPortaat
    this._portaidenLopetukset = []
    const oletuksenIndeksi = this.lisaaAlvPortaat(kayttaja)

    // Oletusporras säilyy osan päältä poistossa, joten uudelleen lisättäessä käytetään olemassa olevaa kenttää
    if (osaRivi().value().oletusporras !== undefined) {
      return
    }
    asetaArvo(osaRivi, { ...osaRivi().value(), oletusporras: oletuksenIndeksi }, { ilmoita: false })
    arvonMuutokset(osaRivi.oletusporras, { injector: this._injector })
      .pipe(takeUntil(this._prosessinOsienLopetus))
      .subscribe(value => {
        let i = 0
        for (const rivi of this._portaat) {
          asetaArvo(rivi.oletus, i === value)
          i++
        }
      })
  }

  private _poistaAlvPortaat(osaRivi: FieldTree<ProsessinOsaLomake>) {
    for (const lopetus of this._portaidenLopetukset) {
      lopetus.next()
      lopetus.complete()
    }
    this._portaidenLopetukset = []
    asetaArvo(osaRivi, { ...osaRivi().value(), alvPortaat: undefined }, { ilmoita: false })
  }

  private _lisaaProsessinOsa(osa: MuokkausprosessinOsa, kayttaja: Kayttaja, maksutavat: AsiakkaanMaksutapa[]) {
    const osat = this.lomake.prosessinOsat().value()
    asetaArvo(this.lomake.prosessinOsat, [...osat, { aktiivinen: osa.valittu ?? null, otsikko: osa.lisaysProsessinOsa.otsikko ?? '' }], { ilmoita: false })
    const osaRivi = this.lomake.prosessinOsat[osat.length]

    if (osa.lisaysProsessinOsa.tunniste === 'editalv') {
      this.naytaAlvPortaat = osa.valittu
      this._portaatOsa = osaRivi
      if (osa.valittu) {
        this.lisaaAlvPortaatJaOletus(osaRivi, kayttaja)
      }
    } else if (osa.lisaysProsessinOsa.tunniste === 'editpaymentmethod') {
      if (osa.valittu) {
        this._lisaaMaksutavat(osaRivi, kayttaja, maksutavat)
      }
      this.naytaMaksutavat = osa.valittu
    }

    const muutokset = <T>(kentta: FieldTree<T>) => arvonMuutokset(kentta, { injector: this._injector }).pipe(takeUntil(this._prosessinOsienLopetus))
    muutokset(osaRivi.aktiivinen).subscribe(value => {
      osa.valittu = value
      if (osa.lisaysProsessinOsa.tunniste === 'editalv') {
        if (osa.valittu) {
          this.lisaaAlvPortaatJaOletus(osaRivi, kayttaja)
        } else {
          this._poistaAlvPortaat(osaRivi)
          this._portaat = null
        }
        this.naytaAlvPortaat = osa.valittu
      } else if (osa.lisaysProsessinOsa.tunniste === 'editpaymentmethod') {
        if (osa.valittu) {
          this._lisaaMaksutavat(osaRivi, kayttaja, maksutavat)
        } else {
          this._poistaMaksutavat(osaRivi)
        }
        this.naytaMaksutavat = osa.valittu
      }
    })
    muutokset(osaRivi.otsikko).subscribe(value => {
      osa.lisaysProsessinOsa.otsikko = this._validationService.processValue(value)
    })
  }

  private navigoiTakaisinListaan() {
    this._router.navigate(['asiakkaat', this.asiakas.avain, 'kayttajat'])
  }

  private annaProsessinOsa(tunniste: string, kayttaja: Kayttaja): TositteenLisaysprosessinOsaMobiilissa | null {
    if (kayttaja && tunniste && kayttaja.prosessinOsat) {
      for (const osa of kayttaja.prosessinOsat) {
        if (osa.tunniste === tunniste) {
          return osa
        }
      }
    }
    return null
  }

  private annaProsessienOsat(kayttaja: Kayttaja): MuokkausprosessinOsa[] {
    const osat: MuokkausprosessinOsa[] = []

    // CAMERA("cameraview", "Kamera", 1),
    const kameraOsa = this.annaProsessinOsa('cameraview', kayttaja)
    const kameraValittu = (!!kameraOsa && !!kayttaja.avain) || !kayttaja.avain
    osat.push({
      lisaysProsessinOsa: kameraOsa
        ? kameraOsa
        : {
            otsikko: 'Kamera',
            tunniste: TositteenLisaysprosessinOsanTunniste.KAMERA,
          },
      valittu: kameraValittu,
    })

    // PAYMENT_METHOD("editpaymentmethod", "Tosite on maksettu", 2),
    const maksutapaOsa = this.annaProsessinOsa('editpaymentmethod', kayttaja)
    const maksutapaValittu = (!!maksutapaOsa && !!kayttaja.avain) || !kayttaja.avain
    osat.push({
      lisaysProsessinOsa: maksutapaOsa
        ? maksutapaOsa
        : {
            otsikko: 'Tosite on maksettu',
            tunniste: TositteenLisaysprosessinOsanTunniste.MAKSUTAPA,
          },
      valittu: maksutapaValittu,
    })

    // AMOUNT("editamount", "Maksun määrä", 3),
    const maaraOsa = this.annaProsessinOsa('editamount', kayttaja)
    const maaraValittu = (!!maaraOsa && !!kayttaja.avain) || !kayttaja.avain
    osat.push({
      lisaysProsessinOsa: maaraOsa
        ? maaraOsa
        : {
            otsikko: 'Maksun määrä',
            tunniste: TositteenLisaysprosessinOsanTunniste.MAKSUN_MAARA,
          },
      valittu: maaraValittu,
    })

    // DATE_AND_DESCRIPTION("editdatedesc", "Lisätiedot", 4),
    const pvmSeliteOsa = this.annaProsessinOsa('editdatedesc', kayttaja)
    const pvmSeliteValittu = (!!pvmSeliteOsa && !!kayttaja.avain) || !kayttaja.avain
    osat.push({
      lisaysProsessinOsa: pvmSeliteOsa
        ? pvmSeliteOsa
        : {
            otsikko: 'Lisätiedot',
            tunniste: TositteenLisaysprosessinOsanTunniste.PVM_SELITE,
          },
      valittu: pvmSeliteValittu,
    })

    // ALV("editalv", "Alv:n vähennysoikeus", 7);
    const alvOsa = this.annaProsessinOsa('editalv', kayttaja)
    const alvValittu = !!alvOsa && !!kayttaja.avain
    osat.push({
      lisaysProsessinOsa: alvOsa
        ? alvOsa
        : {
            otsikko: 'Alv:n vähennysoikeus',
            tunniste: TositteenLisaysprosessinOsanTunniste.ALV_VAHENNYSOIKEUS,
          },
      valittu: alvValittu,
    })

    if (kayttaja && kayttaja.prosessinOsat) {
      let indeksi = 0
      for (const osa of kayttaja.prosessinOsat) {
        let muokkausIndeksi = 0
        for (const muokkausOsa of osat) {
          if (muokkausOsa.lisaysProsessinOsa.tunniste === osa.tunniste) {
            if (indeksi !== muokkausIndeksi) {
              const temp = osat[muokkausIndeksi]
              osat[muokkausIndeksi] = osat[indeksi]
              osat[indeksi] = temp
            }
            break
          }
          muokkausIndeksi++
        }
        indeksi++
      }
    }

    return osat
  }

  async naytaVahvanTunnistautumisenHistoriaa() {
    const historia: StrongAuthenticationSessionHistory[] = await this._firebaseLemonaid
      .firestoreCollection<StrongAuthenticationSessionHistory>('customers/' + this.asiakas.avain + '/customers-users/' + this.kayttaja.avain + '/user-auth-history/')
      .orderBy('logTime', 'desc')
      .limit(100)
      .get()
      .then(snapshots => {
        return snapshots
      })

    console.log(historia)
    this._dialog.open(KayttajaStrongAuthHistoryDialog, { data: historia })
  }

  showKayttajaHistory() {
    if (!this.kayttaja?.avain) {
      return
    }

    this._dialog.open(KayttajaHistoriaDialog, {
      width: '1200px',
      maxHeight: '90vh',
      data: {
        asiakasAvain: this.asiakas.avain,
        kayttaja: this.kayttaja,
      },
    })
  }

  naytaVirhe<T>(kentta: FieldTree<T>, laji: string) {
    const tila = kentta()
    return tila.errors().some(virhe => virhe.kind === laji) && (tila.dirty() || tila.touched())
  }
}

export class RooliMapper {
  static annaBooleanArvo(arvo: any): boolean {
    if (!arvo) {
      return false
    }
    if (typeof arvo === 'boolean') {
      return arvo as boolean
    }
    if (arvo instanceof Boolean) {
      return (arvo as Boolean).valueOf()
    }
    return false
  }
}
